import { __ } from '@wordpress/i18n';
import { MoneyBackBadge } from './icons';

const Guarantee = () => (
    <div className="f-pricing__guarantee">
        <div className="f-pricing__guarantee-text">
            <h3>{__('100% Risk-Free Money Back Guarantee!', 'jeg-elementor-kit')}</h3>
            <p>
                {__('We prioritize your happiness above all else. We proudly offer a 100% satisfaction guarantee, no questions asked,', 'jeg-elementor-kit')}{' '}
                <strong>{__('for a full 14 days', 'jeg-elementor-kit')}</strong>.{' '}
                {__("If you're not satisfied with your purchase, our Customer Happiness Team will promptly refund your investment.", 'jeg-elementor-kit')}
                <br />
                <strong>{__('Upgrade or cancel anytime. Happiness guaranteed.', 'jeg-elementor-kit')}</strong>
            </p>
        </div>
        <MoneyBackBadge />
    </div>
);

export default Guarantee;
